import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `personas`
const plural = 'personas'
const single = 'persona'

const api = new ApiCore({
	index: true,
	findOne: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

api.findUseCasePersona = (personaId, useCaseId) =>{
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${personaId}/${useCaseId}`)
		.then(handleResponse)
		.catch(handleError);
}


export default api
